<template>
  <div class="wrapper">
    小飞棍走喽
    <slot name="title">我是头</slot>
    <slot name="end">我是屁股</slot>
    <slot>无名氏</slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>
// .wrapper{
//   .fade-enter-active, .fade-leave-active {
//     transition: all 3s;
//   }
//   .fade-enter, .fade-leave-to {
//     opacity: 0;
//     width:100px;
//   }
//   p{
//     border:1px solid red;
//     width:300px;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/components/son.vue